import request from '@helpers/request';
import api from '@constants/endpoints';
import { get } from 'lodash';
import moment from 'moment';
import IGame from '@interfaces/IGame';
import { FeaturingFormValue, GameValue } from './FeaturingEditModal.types';
import { IFeaturing, IFeaturingCreate } from '@interfaces/IFeaturing';

export async function fetchGameList(gameName: string): Promise<GameValue[]> {
  return request(api.games.getList, { params: { filter: gameName } }).then((body) => {
    return get(body, ['data', 'body', 'content'], []).map((game: IGame) => ({
      label: game.name,
      value: game.id,
      image: game.image,
    }));
  });
}

export function mapValueToRequest(value: FeaturingFormValue): {
  body: IFeaturingCreate;
  id?: string;
} {
  const res: IFeaturingCreate = {
    postId: +value.postId,
    type: value.type,
    platformIds: value.platformIds,
    gameIds: value.gameIds?.map((gameId) => gameId.value),
  };
  res.startDate = moment(value.date[0]).toISOString();
  res.endDate = moment(value.date[1]).toISOString();
  if (value.locale !== 'all') {
    res.locale = value.locale;
  }
  return { body: res, id: value.id };
}

export function mapDataToFieldsValue(value: IFeaturing): FeaturingFormValue {
  return {
    id: value.id.toString(),
    date: value.endDate ? [moment(value.startDate), moment(value.endDate)] : [null, null],
    gameIds: value.games.map((game) => ({ value: game.id.toString(), label: game.name })),
    type: value.type,
    locale: value.locale || 'all',
    postId: value.post.id.toString(),
    platformIds: value.platforms.map((platform) => platform.id),
  };
}
